"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILIcon = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var ILIcon = function (props) {
    var classes = 'il-icon ' + props.className;
    return (react_1.default.createElement(Box_1.default, { container: props.boxElement || 'span',
        className: classes,
        sx: props.sx },
        props.children,
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: props.size, icon: props.icon, "aria-label": props.icon.iconName })));
};
exports.ILIcon = ILIcon;
